import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { MediaStateChangedEvent } from '../../../shared/events/media-state-changed.event';
import { MediaActionsUnion, MediaActionTypes } from './media.actions';

export const inRoomMediaStateFeatureKey = 'inroom-media-state';

export const adapter: EntityAdapter<MediaStateChangedEvent> = createEntityAdapter<MediaStateChangedEvent>({
  selectId: selectMediaStateIdFromAlarmChangedEvent,
});

export type MediaState = EntityState<MediaStateChangedEvent>;

export function selectMediaStateIdFromAlarmChangedEvent(alarm: MediaStateChangedEvent): string {
  return selectMediaStateId(alarm.HotelCode, alarm.UnitCode);
}

export function selectMediaStateId(hotelCode: string, unitCode: string): string {
  return hotelCode + '-' + unitCode;
}

export const initialState: MediaState = adapter.getInitialState({});

export function mediaReducer(state = initialState, action: MediaActionsUnion): MediaState {
  switch (action.type) {
    case MediaActionTypes.MEDIA_SIGNALR_STATE_CHANGED:
    case MediaActionTypes.MEDIA_EFFECT_MEDIA_RESETTED: {
      return adapter.upsertOne(action.payload.mediaState, state);
    }
  }
  return state;
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectMediaStateIds = selectIds;

export const selectMediaStateEntities = selectEntities;

export const selectAllMediaState = selectAll;

export const selectMediaStateTotal = selectTotal;
